<app-header [title]="title"></app-header>
<div class="redirect-pge">
  <div class="redirect-midd">
    <h4>Page Not Found</h4>
    <span>The page your looking for is not availabe on the iAR application. <br> Please check the url. </span>
  </div>
</div>
